import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';

import { registerDocumentClickBubblingOnTop } from '@itslearning/atlas/frames/IframeClickEventHelper';
import { sendDocumentTitleToParent } from '@itslearning/atlas/frames/IFrameTitleUtils';

import App from './lib/App/App.svelte';
import { mount } from 'svelte';

// @ts-ignore
const data = window.ExternalCourseCatalogueInfoData;

registerDocumentClickBubblingOnTop();
sendDocumentTitleToParent(data.title);

const app = mount(App, {
    target: document.getElementById('external-course-catalogue-info'),
    props: data
});

export default app;
